import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_getInstance1k2utlogu14e7 as Companion_getInstance,
  Badge28jlxgdx0n9um as Badge,
} from '../Badge.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Badge_ResponseAdapterClass;
function Badge_ResponseAdapter() {
  if (Badge_ResponseAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        var rawValue = ensureNotNull(reader.p41());
        return Companion_getInstance().y6s(rawValue);
      }
      v6p(writer, customScalarAdapters, value) {
        writer.r41(value.e6t_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.v6p(writer, customScalarAdapters, value instanceof Badge() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Badge_ResponseAdapter', VOID, VOID, [Adapter()]);
    Badge_ResponseAdapterClass = $;
  }
  return Badge_ResponseAdapterClass;
}
var Badge_ResponseAdapter_instance;
function Badge_ResponseAdapter_getInstance() {
  return Badge_ResponseAdapter_instance;
}
//region block: init
Badge_ResponseAdapter_instance = new (Badge_ResponseAdapter())();
//endregion
//region block: exports
export {
  Badge_ResponseAdapter_instance as Badge_ResponseAdapter_instance3ftsl9x5arf2y,
};
//endregion

//# sourceMappingURL=Badge_ResponseAdapter.mjs.map
